var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('md-layout-header'),_c('section',{staticClass:"md-layout-section"},[_c('md-layout-sidebar'),_c('main',{staticClass:"md-layout-main"},[_c('router-view')],1)],1),_c('md-shared-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }